// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .auth-layout {
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f8f9fa;
    }
  `, "",{"version":3,"sources":["webpack://./apps/clients-portal/src/app/layouts/auth-layout/auth-layout.component.ts"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,yBAAyB;IAC3B","sourcesContent":["\n    .auth-layout {\n      height: 100vh;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: #f8f9fa;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
